import { NO_VALUE_SELECTED_ERROR } from '../../../utils/formValidation/commonErrorConstants';

export const initialErrorState = {
    contractId: { error: true, message: '' }
};

export const validate = (chosenContract, errors) => {
    let isValid = true;
    let newErrors = errors;

    if (!chosenContract || Object.keys(chosenContract).length < 1) {
        newErrors = {
            ...newErrors,
            contractId: { error: true, message: NO_VALUE_SELECTED_ERROR }
        };
        isValid = false;
    }

    if (Object.values(newErrors).some((el) => el.error)) isValid = false;
    return isValid;
};
